<div class="anonymous_retail_order body tab-content">
  <div class="content fade_In">

    <section class="section_1">
      <div class=" row no-margin form_fields ">
        <form [formGroup]="FilteringListForm">
          <!-- store -->
          <div class="col-lg-4 col-sm-4 p-0">
            <div class="col-lg-12 ">
              <select autofocus tabindex="0"  class="form-control" formControlName="store" [attr.disabled]="((isLoading?.participatingStores == tableColumnName?.participatingStores ) ?  '' : null )">
                <option value=" " disabled>{{(isLoading?.participatingStores == tableColumnName?.participatingStores ) ? ('department-system.Loading...' |translate |translateKey) : ('reports.Store' |translate |translateKey | titlecase)}} </option>
                <option *ngFor="let store of retailStoresParticipation;trackBy:trackByStoreID" [value]="store.id">
                  {{store.name}}</option>
              </select>
              <div class="alert-msg fade_In p-2"
              *ngIf="((!FilteringListForm.get('store').valid  && FilteringListForm.get('store').hasError('required')
             && FilteringListForm.get('store').touched) || (FilteringListForm.get('store').touched && FilteringListForm.get('store')?.hasError('noEmptyString'))) ">
              {{'validation-message.Store is required'|translate |translateKey}}
            </div>
            </div>
          </div>
          <!-- Year -->
          <div class="col-lg-4 col-sm-4 p-0">
            <div class=" col-lg-12 ">
              <select  tabindex="0"  class="form-control" formControlName="year">
                <option value=" ">{{'retail-orders.Processing Year' |translate |translateKey |titlecase}}</option>
                <option *ngFor="let year of yearValues" [value]="year">{{year}}</option>
              </select>
            </div>
          </div>
          <!-- Month -->
          <div class="col-lg-4 col-sm-4 p-0">
            <div class=" col-lg-12">
              <select  tabindex="0"  class="form-control" formControlName="month">
                <option value=" ">{{'retail-orders.Processing Month' |translate |translateKey |titlecase}}</option>
                <option *ngFor="let month of monthAndYear" [value]="month?.value">{{month?.monthName}}</option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div class="actions right">
        <div>
          <button class="btn blue-button" tabindex="0" (click)="getRetailBonusSalesRecords()" [disabled]="!FilteringListForm.valid">{{'menu.Search'|translate |translateKey |titlecase}}</button>
          <button class="btn grey-button" tabindex="0" type="button" (click)="resetFilterForm()">{{'menu.Clear'|translate |translateKey |titlecase}}</button>
        </div>
      </div>
      <div>
        <ng-container *ngIf="isAnonymousRetailCreatePermission; else notExist">
          <a  tabindex="0" id="processor-btn" (click)="openRetailModal(tableColumnName.CREATE)">
            <span class="glyphicon glyphicon-plus"></span>
            &nbsp;&nbsp;&nbsp;{{'config-system.ADD NEW' |translate |translateKey}}
          </a>
        </ng-container>
        <ng-template #notExist> &nbsp; </ng-template>
      </div>
    </section>


    <section class="section_2 ">
      <!-- table starts -->
      <div class=" no-padding card margintop-32">
        <div class="table-responsive">
          <table class="table table-hover table-striped custab">
            <thead>
              <tr>
                <th class="pointer w-9" (click)="sortByColumn(tableColumnName.Country)">
                  <div class="flex">
                    <span class="format_text">{{'customer-service.Country' |translate |translateKey}}&nbsp;</span>
                    <span> <i class="fa"
                        [ngClass]="{'fa-sort': sortColumn != tableColumnName.Country, 'fa-sort-asc': (sortColumn == tableColumnName.Country && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.Country && isDesc) }"
                        aria-hidden="true"> </i></span>
                  </div>                
                </th>
                <th class="pointer w-5 text-center" (click)="sortByColumn(tableColumnName.Year)">
                  <div class="flex">
                    <span class="format_text">{{'retail-orders.Year' |translate |translateKey}}&nbsp;</span>
                    <span> <i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.Year, 'fa-sort-asc': (sortColumn == tableColumnName.Year && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.Year && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                   
                </th>
                <th class="pointer w-6 text-center" (click)="sortByColumn(tableColumnName.Month)">
                  <div class="flex">
                    <span class="format_text">{{'incentives.Month' |translate |translateKey}}&nbsp;</span>
                    <span> <i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.Month, 'fa-sort-asc': (sortColumn == tableColumnName.Month && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.Month && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>  
                </th>
                <th class="pointer w-9 text-center" (click)="sortByColumn(tableColumnName.CC)">                  
                    {{'retail-orders.CC' |translate |translateKey}}&nbsp;
                     <i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.CC, 'fa-sort-asc': (sortColumn == tableColumnName.CC && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.CC && isDesc) }"
                      aria-hidden="true"> </i>                              
                </th>
                <th class="pointer  w-9 text-center" (click)="sortByColumn(tableColumnName.Subscribers)">
                  <div class="flex">
                    <span class="format_text">{{'retail-orders.Subscribers' |translate |translateKey}}&nbsp;</span>
                    <span> <i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.Subscribers, 'fa-sort-asc': (sortColumn == tableColumnName.Subscribers && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.Subscribers && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                  
                </th>
                <th class="pointer  w-9 text-center" (click)="sortByColumn(tableColumnName.OrderCC)">
                  <div class="flex">
                    <span class="format_text">{{'reports.Order CC' |translate |translateKey}}&nbsp;</span>
                    <span><i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.OrderCC, 'fa-sort-asc': (sortColumn == tableColumnName.OrderCC && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.OrderCC && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                  
                </th>
                <th class="pointer w-10 text-center" (click)="sortByColumn(tableColumnName.OrderTotal)">
                  <div class="flex">
                    <span class="format_text">{{'reports.Order Total' |translate |translateKey}}&nbsp;</span>
                    <span><i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.OrderTotal, 'fa-sort-asc': (sortColumn == tableColumnName.OrderTotal && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.OrderTotal && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                   
                </th>
                <th class="pointer " (click)="sortByColumn(tableColumnName.ApprovedBy)">
                  <div class="flex">
                    <span class="format_text">{{'retail-orders.Approved By' |translate |translateKey}}&nbsp;</span>
                    <span><i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.ApprovedBy, 'fa-sort-asc': (sortColumn == tableColumnName.ApprovedBy && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.ApprovedBy && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                 
                </th>
                <th class="w-14" (click)="sortByColumn(tableColumnName.ApprovedTimestamp)">
                  <div class="flex">
                    <span class="format_text">{{'retail-orders.Approved Timestamp' |translate |translateKey}}&nbsp;</span>
                    <span><i class="fa"
                      [ngClass]="{'fa-sort': sortColumn != tableColumnName.ApprovedTimestamp, 'fa-sort-asc': (sortColumn == tableColumnName.ApprovedTimestamp && !isDesc), 'fa-sort-desc': (sortColumn == tableColumnName.ApprovedTimestamp && isDesc) }"
                      aria-hidden="true"> </i></span>
                  </div>                  
                </th>
                <th>{{'retail-orders.View Orders' |translate |translateKey}}</th>
                <!--Remove flag for regenerate orders when trb is planned-->
                <th *ngIf="isEnableViewOrderAndRegenerateOrder">{{'retail-orders.Regenerate Orders' |translate |translateKey}}&nbsp; </th>
                <th class="w-6"></th>
              </tr>
            </thead>
            <tbody>
              <tr class="fade_In"
                *ngFor="let  retailSales of RetailBonusSalesData | paginate: { id:'shared-retail-sales-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }; trackBy:trackBySales">
                <td title="{{retailSales?.storeName}}">{{retailSales?.storeName}}</td>
                <td class="text-center" >{{retailSales?.salesYear}}</td>
                <td class="text-center">{{retailSales?.salesMonth}}</td>
                <td class="text-center"  title="{{retailSales?.totalSalesCC}}"><span>{{retailSales?.totalSalesCC}}</span></td>   
                <ng-container [ngSwitch]="!!RetailBonusSalesData?.length">
                  
                  <ng-container *ngSwitchCase="retailSales?.retailBonusStatus == RetailBonusStatus.PENDING">
                    <td colspan=3 class="text-center">
                      <button *ngIf="(retailSales?.isCreate && retailSales?.retailBonusStatus == RetailBonusStatus.PENDING)"
                        class="btn blue-button but_tot_cc"
                        (click)="calculateTotalOrderCC(retailSales)">{{'retail-orders.Calculate Order Total and CC' |translate |translateKey}}</button>
                    </td>
                    <td colspan=2></td>                     
                    <td colspan=2>
                      <div class="actions_icons">
                        <i class="fa fa-pencil color-blue" title="Edit" *ngIf="retailSales?.isEdit"
                          (click)="openRetailModal(tableColumnName.EDIT,retailSales)"></i>
                        <i class="fa fa-trash del-icon" title="Delete" *ngIf="retailSales?.isDelete"
                          (click)="confirmation(retailSales)"></i>
                          <span class="pointer" (click)="getRetailLogs(retailSales)">
                            <img  [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                           </span>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container *ngSwitchCase="retailSales?.retailBonusStatus == RetailBonusStatus.QUALIFIED_SUBSCRIBER_NOT_AVAILABLE">
                    <td colspan=4 class="text-center fw-bold">
                      <span>{{'retail-orders.Qualified subscribers are not available in this store for current month' |translate |translateKey }} </span>
                    </td>
                    <td colspan=3><span class="log_image d-end pointer" (click)="getRetailLogs(retailSales)">
                      <img  [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                     </span></td>
                  </ng-container>
                  
                  <ng-container *ngSwitchCase="retailSales?.retailBonusStatus == RetailBonusStatus.SUBSCRIBER_NOT_AVAILABLE">
                    <td colspan=4 class="text-center fw-bold">
                      <span>{{'retail-orders.Subscribers are not available in this store for current month' |translate |translateKey }}</span> </td>
                    <td colspan=3>
                      <span class="log_image d-end pointer" (click)="getRetailLogs(retailSales)">
                        <img  [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                       </span>
                    </td>
                  </ng-container>

                  <ng-container
                    *ngSwitchCase="retailSales?.retailBonusStatus == RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS">
                    <td colspan=4 class="text-center fw-bold ">
                     <span>{{'retail-orders.Order total calculation in progress' |translate |translateKey }}</span> </td>
                    <td colspan=3>
                      <span class="log_image d-end pointer" (click)="getRetailLogs(retailSales)">
                        <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                      </span></td>
                  </ng-container>
    
                  <ng-container
                    *ngSwitchCase="(retailSales?.retailBonusStatus == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS || retailSales?.retailBonusStatus == RetailBonusStatus.REVISE_INPROGRESS) ||
        (retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS || retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS ||
                      retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_FAILED || retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_INPROGRESS || retailSales?.retailBonusStatus ==  RetailBonusStatus.ORDER_GENERATION_FAILED || retailSales?.retailBonusStatus ==  RetailBonusStatus.ORDER_GENERATION_SUCCESS)">
                    <td class="text-center">{{retailSales?.qualifiedSubscriberCount}}</td>
                    <td title="{{retailSales?.orderCC}}" class="text-center">{{retailSales?.orderCC }}</td>
                    <td title="{{retailSales?.orderTotal}}{{retailSales?.orderTotal ? retailSales?.currencyCode : ''}}" class="text-center">{{retailSales?.orderTotal}}
                      {{retailSales?.orderTotal ? retailSales?.currencyCode : ''}}</td>
                    <ng-container
                      *ngIf="(retailSales?.retailBonusStatus == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS || retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_FAILED)">
                      <td colspan=1><button *ngIf="(retailSales?.isApprove)" class="btn blue-button but_tot_cc"
                          (click)="approve(retailSales)">Approve</button></td>
                      <td colspan=1><button *ngIf="(retailSales?.isApprove)" class="btn blue-button but_tot_cc"
                          (click)="reviseRetailOrder(retailSales)">Revise</button></td>
                      <td colspan=2 class=" fw-bold">
                        <span [ngClass]="(retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_FAILED)?'d-end':'right'">
                        <ng-container *ngIf="(retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_FAILED)">
                         <span class="fb-100">{{ ('retail-orders.Order generation failed' |translate |translateKey) }}</span> </ng-container>
                         <span class="pointer " (click)="getRetailLogs(retailSales)">
                          <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                        </span>
                         </span>
                      </td>   
                    </ng-container>

                    <ng-container *ngIf="retailSales?.retailBonusStatus == RetailBonusStatus.REVISE_INPROGRESS">
                      <td colspan=4 class="text-center fw-bold">
                        <span class="d-end">
                        <span class="fb-100">{{'retail-orders.Revise in progress' |translate |translateKey}}</span>
                        <span class="pointer" (click)="getRetailLogs(retailSales)">
                          <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                        </span>
                      </span>
                      </td>
                    </ng-container>
    
                    <ng-container
                      *ngIf="(retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS || retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS ||
        retailSales?.retailBonusStatus == RetailBonusStatus.PRODUCT_FILE_UPLOAD_FAILED || retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_INPROGRESS || retailSales?.retailBonusStatus ==  RetailBonusStatus.ORDER_GENERATION_SUCCESS)">
                      <td title="{{retailSales?.approvedBy |titlecase}}">{{retailSales?.approvedBy |titlecase}}</td>
                      <td title="{{retailSales?.approvedDate}}">{{retailSales?.approvedDate |date:'dd/MM/yyyy hh:mm:ss a' }}
                      </td>
                      <td colspan=2 class="text-center fw-bold"
                        *ngIf="(retailSales?.retailBonusStatus != RetailBonusStatus.ORDER_GENERATION_SUCCESS )">
                        <span class="d-end">
                          <span class="fb-100" title="{{('retail-orders.Order generation in progress' |translate |translateKey)}}" >{{ ('retail-orders.Order generation in progress' |translate |translateKey) }}</span>
                          <span class="pointer" (click)="getRetailLogs(retailSales)">
                            <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                          </span>                      
                        </span>                        
                        </td>
                      <td colspan=2 class="text-center fw-bold"
                        *ngIf="(retailSales?.retailBonusStatus == RetailBonusStatus.ORDER_GENERATION_SUCCESS )">
                        <span class="d-end">
                        <span class="fb-100"><a (click)="OnclickViewOrders(retailSales?.id)">{{'retail-orders.View Orders' |translate |translateKey}}</a></span>                      
                        <span class="pointer" (click)="getRetailLogs(retailSales)">
                          <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                        </span>
                        </span>

                      </td> 
                        <!--retailSales?.isShowRegenerateOrder === true put the condition in ng-if once regenerate order task is planned -->
                        <td colspan=2 class=" fw-bold"
                        *ngIf="isEnableViewOrderAndRegenerateOrder">
                          <span class="d-end">
                            <span class="fb-100"><a (click)="OnclickRegenerateOrders()">{{'retail-orders.Regenerate Orders' |translate |translateKey}}</a></span>                      
                            <span class="pointer" (click)="getRetailLogs(retailSales)">
                              <img [imgSrc]="'/images/log-icon.png'" alt="log_Icon">
                            </span>
                            </span>  
                          </td> 
                   </ng-container>
                  </ng-container>
    
                  <ng-container *ngSwitchDefault>
                    <td colspan="7"></td>
                  </ng-container>
    
                </ng-container> 
              </tr>  
            </tbody>

            <tbody *ngIf="pageCount===0">
              <tr>
                <td class="text-center" colspan="11">{{'ticketing-system.No records found' |translate |translateKey}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
        <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
        </pagination-controls>
      </div>
    
    </section>

  </div>
</div>


<!-- popup for addnew anonymous-retail-sales -->
<modal #addNewAnonymousRetailOrders class="anonymousRetailOrders_modal ">
  <modal-header>
    <div class="color-blue">
      {{(!isUpdate) ? ('config-system.ADD' |translate |translateKey) : ('config-system.UPDATE' |translate |translateKey) }}
    </div>
  </modal-header>
  <modal-content>
    <form [formGroup]="CreateOrEditForm" (ngSubmit)="onSubmit()">
      <div class="err_Msg {{message?.class}} h-35 fade_In" *ngIf="message?.value">
        <!-- <div class="icon"><i class="fa fa-{{message?.icon}}" aria-hidden="true"></i></div> -->
        <div class="message">{{message?.msg}}</div>
      </div>
      <div class="add_new_content fade_In">
        <!-- store -->
        <div class="row">
          <div class="col-sm-3">
            <label for="Country"> {{'reports.Store' |translate |translateKey |titlecase }}</label>
            <span class="fa fa-question-circle tooltip-color " triggers="mouseenter:mouseleave"
              containerClass="popover-width"
              popover="{{'retail-orders.Select the Country (Store) for which you want to add Shared Retail sales' |translate |translateKey}}">
            </span>
          </div>
          <div class="col-sm-6 floating-input">
            <select *ngIf="!isUpdate" autofocus tabindex="0"  formControlName="store"
            [attr.disabled]="((isLoading?.retailStores == tableColumnName?.currentRetailStores ) ?  '' : null )" class="form-control">
              <option value=''>{{(isLoading?.retailStores == tableColumnName?.currentRetailStores ) ? ('department-system.Loading...' |translate |translateKey) : ('config-system.--Select--' |translate |translateKey | titlecase)}}</option>
              <option *ngFor="let store of retailStores " [value]="store.id">{{store.name}}</option>
            </select>
            <input *ngIf="isUpdate" tabindex="0" type="text" class="form-control" disabled value="{{updateStoreName}}">

            <div class="alert-msg fade_In p-2"
              *ngIf="((!CreateOrEditForm.get('store').valid  && CreateOrEditForm.get('store').hasError('required')
             && CreateOrEditForm.get('store').touched) || (CreateOrEditForm.get('store').touched && CreateOrEditForm.get('store')?.hasError('noEmptyString'))) ">
              {{'validation-message.Store is required'|translate |translateKey}}
            </div>
          </div>
        </div>

        <!-- year  -->
        <div class="row">
          <div class="col-sm-3">
            <label for="SalesForYear">{{'retail-orders.Sales for Year' |translate |translateKey }}</label>
            <span class="fa fa-question-circle tooltip-color " triggers="mouseenter:mouseleave"
              containerClass="popover-width"
              popover="{{'retail-orders.The Year for which you are adding Shared Retail sales' |translate |translateKey}}">
            </span>
          </div>
          <div class="col-sm-6 floating-input">
            <input tabindex="0" type="text" class="form-control" formControlName="year">
            <div class="alert-msg"
              *ngIf="!CreateOrEditForm.get('year').valid  && CreateOrEditForm.get('year').hasError('required') && CreateOrEditForm.get('year').touched ">
              {{'validation-message.Sales for Year is required'|translate |translateKey}}
            </div>
          </div>
        </div>

        <!--  SalesForMonth-->
        <div class="row">
          <div class="col-sm-3">
            <label for="SalesForMonth">{{'retail-orders.Sales for Month' |translate |translateKey }}</label>
            <span class="fa fa-question-circle tooltip-color " triggers="mouseenter:mouseleave"
              containerClass="popover-width"
              popover="{{'retail-orders.The Month of the Year for which you are adding Shared Retail sales' |translate |translateKey}}">
            </span>
          </div>
          <div class="col-sm-6 floating-input">
            <input tabindex="0" type="text" class="form-control" formControlName="month">
            <div class="alert-msg"
              *ngIf="!CreateOrEditForm.get('month').valid  && CreateOrEditForm.get('month').hasError('required') && CreateOrEditForm.get('month').touched ">
              {{'validation-message.Sales for Month is required'|translate |translateKey}}
            </div>
          </div>
        </div>
        <!-- Total Sales CC -->
        <div class="row">
          <div class="col-sm-3">
            <label for="Total Sales CC">{{'retail-orders.Total Sales CC' |translate |translateKey }}</label>
            <span class="fa fa-question-circle tooltip-color " triggers="mouseenter:mouseleave"
              containerClass="popover-width_total_sales"
              popover="{{'retail-orders.TotalSales CC tooltip-1' |translate |translateKey}}.{{'retail-orders.TotalSales CC tooltip-2'|translate |translateKey}}.{{'retail-orders.TotalSales CC tooltip-3'|translate |translateKey}}">
            </span>
          </div>
          <div class="col-sm-6 floating-input">
            <input id="TotalSalesInput-focus" tabindex="0" type="text" [appDecimal]="digitsAndDecimals" class="form-control"
              formControlName="salesCC">
            <div class="alert-msg"
              *ngIf="!CreateOrEditForm.get('salesCC').valid  && CreateOrEditForm.get('salesCC').hasError('required') && CreateOrEditForm.get('salesCC').touched ">
              {{'validation-message.Total Sales CC is required'|translate |translateKey}}
            </div>
            <div class="alert-msg"
            *ngIf="CreateOrEditForm.get('salesCC').hasError('pattern')">
            {{'validation-message.Please enter a valid format (0-7/0-3)'|translate |translateKey}}
          </div>
          </div>

        </div>

        <div class="actions right mt-20">
          <div>
            <button class="btn blue-button" id="search-button" tabindex="0" type="submit"
              [disabled]="!CreateOrEditForm.valid" *ngIf="hideButton">
              {{(!isUpdate) ? ('config-system.ADD' |translate |translateKey) : ('config-system.UPDATE' |translate |translateKey) }}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeRetailModal()">
              {{'config-system.CANCEL' |translate |translateKey}}
            </button>
          </div>
        </div>

      </div>
    </form>

  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>

<!-- confirmation popup for deleting anonymous-retail-sales -->
<modal #confirmationModal class="confirmation_modal">
  <modal-content>
    <div class="err_Msg {{message?.class}} fade_In" *ngIf="message?.value">
      <!-- <div class="icon"><i class="fa fa-{{message?.icon}}" aria-hidden="true"></i></div> -->
      <div class="message">{{message?.msg}}</div>
    </div>
    <div class="confirmation_content">
      <div class="confirmation_heading">
        <h2>{{'retail-orders.ARE YOU SURE YOU WANT TO DELETE THIS RECORD?' |translate |translateKey }}</h2>
      </div>
      <div class="but_actions mt-20">
        <button class="btn blue-button" tabindex="0" type="button" [disabled]="!hideButton" (click)="deleteRetailSalesRecord()">
          {{'delete-modal.Yes' |translate |translateKey |uppercase}}
        </button>
        <button class="btn grey-button" tabindex="0" type="button" (click)="closeConfirmationPopup()">
          {{'delete-modal.No' |translate |translateKey |uppercase}}
        </button>
      </div>
    </div>
  </modal-content>
</modal>

<modal #viewOrdersModal class="order-detail-modal">
  <modal-header></modal-header>
  <modal-content>
    <div class="table-responsive">
      <table class="table table-hover table-striped custab">
        <thead>
          <tr>
            <th>
              {{'orderdetails.Order Date' |translate |translateKey}}
            </th>
            <th>
              {{'orderdetails.Web Order #' |translate |translateKey}}
            </th>
            <th>
              {{'orderdetails.Status' |translate |translateKey}}
            </th>
            <th>
              {{'customer-service.Country' |translate |translateKey}}
            </th>
            <th class="sponsor-width">
              {{'orderdetails.Sponsor' |translate |translateKey}}
            </th>
            <th>
              {{'orderdetails.Total' |translate |translateKey}}
            </th>
            <th>
              {{'customer-service.Curr' |translate |translateKey}}
            </th>
            <th>
              {{'orderdetails.CC' |translate |translateKey}}
              <span class="close-order-details" (click)="viewOrdersPopup.close()">X</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <app-loader></app-loader>
          <tr
            *ngFor="let orderDetail of anonymousRetailOrderDetails | paginate: { id:'order-detail-pagination', itemsPerPage: orderDetailPageSize, currentPage: orderDetailPageNumber, totalItems: orderDetailPageCount };">
            <td>
              {{orderDetail?.orderDate}}
            </td>
            <td>
              <a> {{orderDetail?.webOrderID}}</a>
            </td>
            <td>
              {{orderDetail?.orderGenerationStatus}}
            </td>
            <td>
              {{orderDetail?.storeName}}
            </td>
            <td>
              {{orderDetail?.distributorId | numberformat}}
            </td>
            <td>
              {{orderDetail?.orderTotal | number:'1.2-2'}}
            </td>
            <td>
              {{orderDetail?.currencyCode}}
            </td>
            <td>
              {{orderDetail?.orderCC | number:'1.3-3'}}
            </td>
          </tr>
          <tr *ngIf="anonymousRetailOrderDetails && anonymousRetailOrderDetails.length === 0 && noRecordExist">
            <td colspan="8" class="text-center">
              {{'retail-orders.No Records found' | translate | translateKey}}
            </td>
          </tr>
          <tr *ngIf="anonymousRetailOrderDetails && anonymousRetailOrderDetails.length === 0 && isErrorOccured">
            <td colspan="8" class="text-center alert-text">
              {{'customer-service.Something went wrong, Please try again after sometime' | translate | translateKey}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    {{orderDetailPageCount}} {{'ticketing-system.record(s) found' |translate}}
    <pagination-controls [id]="orderDetailPaginationInstance.id" (pageChange)="pageChangeForOrderDetail($event)"
      class="pull-right">
    </pagination-controls>
  </modal-content>
</modal>

<modal #viewStatusModal class="status-modal">
  <modal-header>
    <div class="status_modal_close_Icon"><i (click)="statusClose()" class="fa fa-times f-18 pointer" aria-hidden="true"></i></div>
    <div class="text-center status_header fade_In">{{'retail-orders.Shared Retail Program logs' | translate | translateKey}}</div>
  </modal-header>
  <modal-content>
    <div class="status_modal_content">
      <div class="records_info">
        <span *ngIf="retailInfoObj?.storeName"> <i class="fa fa-angle-double-right fs-18" aria-hidden="true"></i>
          {{retailInfoObj?.storeName |titlecase}} </span>
        <span *ngIf="retailInfoObj?.salesYear"> <i class="fa fa-angle-double-right fs-18" aria-hidden="true"></i>
          {{retailInfoObj?.salesYear}}</span>
        <span *ngIf="retailInfoObj?.month"> <i class="fa fa-angle-double-right fs-18" aria-hidden="true"></i>
          {{retailInfoObj?.month}} </span>
      </div>

      <div class="task_status">
        <div *ngFor="let status of retailInfoObj?.logStatus;let i=index" class="fade_In task_status_content"  [ngClass]=" i == 0 ? 'pt-10' :'pt-20'">
          <div class="icon_section" [ngClass]="status?.active" style="display:flex;margin-left:1px">
            <i class="icon_content" [ngClass]="status?.logIconClass" aria-hidden="true"></i>
          </div>
          <div class="message fs-16 w-90" [ngClass]="{'check_icon_color':(status.logStatus==tableColumnName.Completed && (status.logMsgStatus==tableColumnName.Completed || status.logMsgStatus==tableColumnName.Revision)) , 
'pending_icon_color':(status.logStatus==tableColumnName.Pending && (status.logMsgStatus==tableColumnName.Progress || status.logMsgStatus==tableColumnName.Completed || status.logMsgStatus==tableColumnName.Revision)) ,
'progress_color':(status.logStatus==tableColumnName.Completed && status.logMsgStatus==tableColumnName.Progress),
'alert-text':status.logStatus==tableColumnName.FAILED}">
            {{status.logMessage}}
          </div>
        </div>
      </div>
    </div>
  </modal-content>
</modal>



<!-- spinner with overlay -->
<div class="overlay" *ngIf="overlay">
  <div><i class="fa fa-spinner fa-spin spinner_icon "></i></div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/orders/anonymous-retail-order.component.html